import SchoolAssetLoader from "./general/util/SchoolAssetLoader";
export const assetLoader = new SchoolAssetLoader();
import ScreenResizer from "../libs/phaserextension/display/ScreenResizer"
export const screenResizer = new ScreenResizer();
import * as SafeUtils from "../libs/phaserextension/utils/Safe"
export { SafeUtils };
import Flump from "../libs/phaserextension/flump/Flump";
export const flump = new Flump();
import AudioPlayer from "../libs/phaserextension/audio/AudioPlayer";
export const audioPlayer = new AudioPlayer();
